import { http } from '../lib/http/client'

export interface ThemeProperty {
    id: number
    theme_id: number
    key: string
    type: string
    value: { value: string | boolean | number }
}

export interface Theme {
    id: number
    company_id: number
    name: string
    is_active: boolean
    properties?: ThemeProperty[]
}

export const themeService = {
    async getCurrentTheme(): Promise<Theme | null> {
        const response = await http.get('/themes/current')
        return response.data.data
    },

    async updateCurrentTheme(properties: Record<string, { type: string; value: any }>): Promise<Theme> {
        const response = await http.put(`/themes/current`, { properties })
        return response.data.data
    }
}
